import { render, staticRenderFns } from "./ProductPricing.vue?vue&type=template&id=68c961b2&scoped=true&"
import script from "./ProductPricing.vue?vue&type=script&lang=js&"
export * from "./ProductPricing.vue?vue&type=script&lang=js&"
import style0 from "./ProductPricing.vue?vue&type=style&index=0&id=68c961b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c961b2",
  null
  
)

export default component.exports